/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LiteAppPostData, LiteAppPostDataParam } from '@/Interfaces/I_LiteApp';
import { VersionData } from '@/Interfaces/common';

export const LiteAppSlice = createSlice({
  name: 'LiteAppSlice',
  initialState: {
    value: {
      liteAppPosts: [] as LiteAppPostData[],
      version: 0,
    },
    loading: false,
    error: '',
  },
  reducers: {
    getLiteAppPosts: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setLiteAppPosts: (state, action: PayloadAction<VersionData<LiteAppPostData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        liteAppPosts: action.payload.data,
        version: action.payload.version,
      };
      assignState.loading = false;
    },
    setLiteAppPostSuccess: (state, action) => {
      const assignState = state;
      const { postUuid } = action.payload;

      const postIdx = assignState.value.liteAppPosts.findIndex((post) => post.uuid === postUuid);
      if (postIdx !== -1) {
        assignState.value.liteAppPosts[postIdx] = action.payload;
      }
    },
    createLiteAppPost: (_state, _action: PayloadAction<VersionData<LiteAppPostDataParam>>) => {
      const assignState = _state;
      assignState.loading = true;
      assignState.error = '';
    },
    createLiteAppPostSuccess: (state, action: PayloadAction<VersionData<LiteAppPostData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        liteAppPosts: action.payload.data,
        version: action.payload.version,
      };
      assignState.loading = false;
    },
    deleteLiteAppPost: (_state, _action: PayloadAction<VersionData<string>>) => {
      const assignState = _state;
      assignState.loading = true;
    },
    deleteLiteAppPostSuccess: (state, action: PayloadAction<VersionData<LiteAppPostData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        liteAppPosts: action.payload.data,
        version: action.payload.version,
      };
      assignState.loading = false;
    },
    updateLiteAppPosts: (state, _action: PayloadAction<VersionData<LiteAppPostDataParam[]>>) => {
      const assignState = state;
      assignState.loading = true;
    },
    updateLiteAppPostsSuccess: (state, action: PayloadAction<VersionData<LiteAppPostData[]>>) => {
      const assignState = state;
      assignState.value = {
        ...assignState.value,
        liteAppPosts: action.payload.data,
        version: action.payload.version,
      };
      assignState.loading = false;
    },
    liteAppFailure: (state, _action) => {
      const assignState = state;
      assignState.loading = false;
    },
  },
});

export const {
  getLiteAppPosts,
  setLiteAppPosts,
  setLiteAppPostSuccess,
  createLiteAppPost,
  createLiteAppPostSuccess,
  deleteLiteAppPost,
  deleteLiteAppPostSuccess,
  updateLiteAppPosts,
  updateLiteAppPostsSuccess,
  liteAppFailure,
} = LiteAppSlice.actions;

export default LiteAppSlice.reducer;
